/* eslint-disable object-curly-newline */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react';
import Lottie from 'react-lottie';
import Emoji from 'react-emoji-render';
import { Link } from 'react-router-dom';
import { MdInfoOutline } from 'react-icons/md';
import { UncontrolledTooltip } from 'reactstrap';

import history from '~/services/history';
import api from '~/services/api';
import { Container, Card, ContainerFailed, ViewToolTip } from './styles';
import loadingContent from '~/assets/animations/loadingContent.json';

export default function Dashboard() {
  const [modules, setModules] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    async function getData() {
      const { data } = await api.get('/subjects');

      setModules(data);
    }

    getData();
  }, []);

  return (
    <>
      {modules.length >= 1 ? (
        <>
          <p
            style={{
              fontSize: 26,
              paddingLeft: 30,
              paddingTop: 30,
              color: '#36DED6',
              fontWeight: 'bold',
            }}
          >
            Desafios da Apollo Partners
          </p>
          <p
            style={{
              fontSize: 20,
              paddingLeft: 60,
              color: '#36DED6',
              fontWeight: 'bold',
              marginTop: 40,
            }}
          >
            Desafios de Programaçāo:
            <MdInfoOutline
              size={20}
              color="#36ded6"
              style={{ marginBottom: -3.5, marginLeft: 5, cursor: 'pointer' }}
              id="infoProgramming"
            />
          </p>
          <UncontrolledTooltip
            delay={0}
            placement="right-start"
            target="infoProgramming"
          >
            <ViewToolTip>
              <p>
                Os Desafios de programaçāo sāo exercícios das áreas e
                competências sobre tecnologia. Temos diversas áreas de
                conhecimento, desenvolvimento web, desenvolvimento mobile,
                desenvolvimento back-end e outros.
              </p>
              <p>
                Cada módulo possui seus níveis de dificuldade, iniciando do
                nível Iniciante e terminando no nível Master. Fazer os desafios
                é fundamental para você aumentar seu nível Apollo e ter a chance
                de trabalhar nas melhores vagas disponíveis.
              </p>
            </ViewToolTip>
          </UncontrolledTooltip>
          <Container>
            {modules.map((module) => {
              if (module.type === 'development') {
                return (
                  <Link key={module.id} to={`dashboard/${module.id}`}>
                    <Card>
                      <span>
                        <img
                          src={module.file.url}
                          alt={`module.${module.id}`}
                          resize="cover"
                        />
                      </span>
                      <div className="content">
                        <p style={{ fontWeight: 'bold', fontSize: 16 }}>
                          {module.title}
                        </p>
                        <p style={{ textAlign: 'initial', fontSize: 14 }}>
                          {module.description}
                        </p>
                      </div>
                    </Card>
                  </Link>
                );
              }
              return null;
            })}
          </Container>
          <p
            style={{
              fontSize: 20,
              paddingLeft: 60,
              color: '#36DED6',
              fontWeight: 'bold',
              marginTop: 40,
            }}
          >
            Desafios de Negócios:
            <MdInfoOutline
              size={20}
              color="#36ded6"
              style={{ marginBottom: -3.5, marginLeft: 5, cursor: 'pointer' }}
              id="infoBusiness"
            />
          </p>
          <UncontrolledTooltip
            delay={0}
            placement="right-start"
            target="infoBusiness"
          >
            <ViewToolTip>
              <p>
                Atualmente para o profissional de tecnologia que quer se
                destacar e ter uma rápida evoluçāo na sua carreira, é
                fundamental ter conhecimento sobre negócios. As empresas
                valorizam mais os profissionais que conhecem o mercado e o
                modelo de negócio que ela está inserida.
              </p>
              <p>
                Aqui você pode fazer os desafios de diversas áreas de negócio e
                mercado, e conseguir seu certificado para se destacar ainda mais
                na plataforma.
              </p>
            </ViewToolTip>
          </UncontrolledTooltip>
          <Container>
            {modules.map((module) => {
              if (module.type === 'business') {
                return (
                  <Card
                    key={module.id}
                    onClick={() => history.push(`/dashboard/${module.id}`)}
                  >
                    <span>
                      <img src={module.file.url} alt={`module.${module.id}`} />
                    </span>
                    <div className="content">
                      <p style={{ fontWeight: 'bold' }}>{module.title}</p>
                      <p style={{ textAlign: 'justify' }}>
                        {module.description}
                      </p>
                    </div>
                  </Card>
                );
              }
              return null;
            })}
          </Container>
          {/* <p
            style={{
              fontSize: 20,
              paddingLeft: 60,
              color: '#36DED6',
              fontWeight: 'bold',
              marginTop: 40,
            }}
          >
            Desafios Mentalidade Apollo:
            <MdInfoOutline
              size={20}
              color="#36ded6"
              style={{ marginBottom: -3.5, marginLeft: 5, cursor: 'pointer' }}
              id="infoMentality"
            />
          </p>
          <UncontrolledTooltip
            delay={0}
            placement="right-start"
            target="infoMentality"
          >
            <ViewToolTip>
              <p>
                Os conhecimentos técnicos e de negócios, sem dúvida, sāo
                fundamentais. Porém algo essencial para qualquer tipo de pessoa
                e profissional é ter a mentalidade correta, para: definir seus
                objetivos, planejar seu plano de açāo e ter disciplina para
                alcança-los.
              </p>
              <p>
                Os Desafios da Mentalidade Apollo, sāo Desafios para melhorar seu
                auto-conhecimento e ajudá-lo a atingir seus objetivos. A
                Mentalidade Apollo sāo as melhores ideais e conceitos que os
                Apollo Partners juntaram pra te ajudar.
              </p>
            </ViewToolTip>
          </UncontrolledTooltip>
          <Container style={{ paddingBottom: 40 }}>
            {modules.map((module) => {
              if (module.type === 'apollo') {
                return (
                  <Card
                    key={module.id}
                    onClick={() => history.push(`/dashboard/${module.id}`)}
                  >
                    <span>
                      <img src={module.file.url} alt={`module.${module.id}`} />
                    </span>
                    <div className="content">
                      <p style={{ fontWeight: 'bold' }}>{module.title}</p>
                      <p style={{ textAlign: 'justify' }}>
                        {module.description}
                      </p>
                    </div>
                  </Card>
                );
              }
              return null;
            })}
          </Container> */}
          <p
            style={{
              fontSize: 20,
              paddingLeft: 60,
              color: '#36DED6',
              fontWeight: 'bold',
              marginTop: 40,
            }}
          >
            Desafios de Projetos:
            <MdInfoOutline
              size={20}
              color="#36ded6"
              style={{ marginBottom: -3.5, marginLeft: 5, cursor: 'pointer' }}
              id="infoBusiness"
            />
          </p>
          <UncontrolledTooltip
            delay={0}
            placement="right-start"
            target="infoBusiness"
          >
            <ViewToolTip>
              <p>
                No Desafio de Projetos você irá simular projetos reais para que
                você treine suas habilidades de tecnologia e de negócios.
              </p>
              <br />
              <p>Cada categoria possui alguns Projetos para você realizar.</p>
            </ViewToolTip>
          </UncontrolledTooltip>
          <Container>
            {modules.map((module) => {
              if (module.type === 'project') {
                return (
                  <Card
                    key={module.id}
                    onClick={() => history.push(`/dashboard/${module.id}`)}
                  >
                    <span>
                      <img src={module.file.url} alt={`module.${module.id}`} />
                    </span>
                    <div className="content">
                      <p style={{ fontWeight: 'bold' }}>{module.title}</p>
                      <p style={{ textAlign: 'justify' }}>
                        {module.description}
                      </p>
                    </div>
                  </Card>
                );
              }
              return null;
            })}
          </Container>
        </>
      ) : (
        <ContainerFailed>
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: loadingContent,
            }}
            height={300}
            width={300}
          />
          <Emoji
            text="Se a página nāo carregar, clique no botāo abaixo.😀"
            style={{ color: '#fff', fontSize: 24, marginTop: -30 }}
          />
          ;
          <button type="submit" onClick={() => window.location.reload()}>
            <Emoji
              text="Carregar 💻"
              style={{ color: '#fff', fontSize: 18, fontWeight: 'bold' }}
            />
          </button>
        </ContainerFailed>
      )}
    </>
  );
}
